<template>
    <div class="row">
        <form class="ministry-form form-horizontal" @submit.prevent="submit()">
            <div class="form-group" :class="{'has-error': errors['nombre']}">
                <label for="nombre" class="col-sm-2 control-label">Nombre Canal</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="nombre" v-model="data.nombre" maxlength="200" autocomplete="off"/>
                    <div class="help-block" v-for="e in errors['nombre']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['url']}">
                <label for="url" class="col-sm-2 control-label">URL</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="url" v-model="data.url" maxlength="200" autocomplete="off" />
                    <div class="help-block" v-for="e in errors['url']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['icono']}">
                <label for="icono" class="col-sm-2 control-label">Imagen</label>
                <div class="col-sm-10">
                    <help-channel-image id="icono" v-model="data.icono" :images="this.images"></help-channel-image>
                    <div class="help-block" v-for="e in errors['icono']">{{e}}</div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <a :href="this.retorno" class="btn btn-danger">Cancelar</a>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ElementUI from "element-ui";
import HelpChannelImage from "./HelpChannelImage.vue";

export default {
    data: function() {
        const channel = _.cloneDeep(this.channel);
        const channels_institution = _.cloneDeep(this.channels_institution);
        return {
            data: channel,
            token: window.token.content,
            errors: {},
            dataSubmit: [],
            icono : '',
        };
    },
    name: "HelpChannelForm",
    props: ['channel','channels_institution','edit', 'images', 'retorno'],
    components: {
        HelpChannelImage,
    },
    mounted() {
        if (this.edit == true){
            this.icono  = this.channel.icono;
            this.data.icono = this.icono.replace('images/','');
        }
    },
    methods:{
        submit: function(){
            let self    = this;
            self.errors = {};
            let errores = {};
            let valido  = true;

            if (!self.data.nombre || self.data.nombre.length == 0) {
                errores["nombre"] = ["Debe ingresar un nombre de canal"];
                valido = false;
            }
            
            if (!self.data.url || self.data.url.length == 0) {
                errores["url"] = ["Debe ingresar una url valida"];
                valido = false;
            }
            
            if (!self.data.icono || self.data.icono.length == 0) {
                errores["icono"] = ["Debe seleccionar una imagen"];
                valido = false;
            }
            
            if (!valido) {
                self.errors = errores;
                return false;
            }

            self.dataSubmit.push(Object.assign({},self.data));
            self.dataSubmit.push(self.channels_institution);
            
            axios({
                url: self.edit ? 'backend/channels/'+self.data.id : 'backend/channels',
                method: self.edit ? 'PUT' : 'POST',
                data: self.dataSubmit,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }
    }
}  
</script>

<style lang="scss" scoped>
  .el-select{
    display: block;
  }  
</style>
